export default __webpack_public_path__ + "static/media/fav-list-add-white.03bd07a5.svg";